// extracted by mini-css-extract-plugin
export default {"carousel":"EiVbV","carouselItem":"v506u","mainImage":"MmLa6","thumbnailContainer":"pm6IX","thumbnail":"_UVd5"};